import { Component, OnInit, Injector, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { BillingModel, CommonModel } from 'src/modules/payment/components/common/billing.model';
import { ActivatedRoute } from '@angular/router';
import { BillingService } from 'src/modules/payment/service/billing.service';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { PayorDetailsItemConsumptionComponent } from '../payor-details-item-consumption/payor-details-item-consumption.component';
import { SearchAndSelect } from 'src/modules/base/components/form/models/serachselect.model';
import { CommonService } from 'src/modules/base/services/common.service';

@Component({
    selector: 'kx-op-item-consumption-payer',
    templateUrl: './op-item-consumption-payer.component.html',
    standalone: false
})
export class OpItemConsumptionPayerComponent extends MainComponent implements OnInit {
  billingModel: BillingModel;
  @ViewChild("treatingDcotorSelector") treatingDcotorSelector: any;
  commonModel: CommonModel;
  @Input() patientInfo: any;
  @Output() updatePayorInfo: EventEmitter<any> = new EventEmitter();
  payerExpired: boolean = false;
 
  payerQuestion = new SearchAndSelect({
    datasource: { 
      "application": "facility-management",
      "resource": "payer",
      "query_id": "GET_PAYER",
      "args": "payer_for:op_billing",
    },
    defaultsetting: {
      "singleSelection": true,
      "allowSearchFilter": true,
      "closeDropDownOnSelection": true,
      "checkBoxRequired": false,
      "apliCall": false
    },
    getterKey: 'id',
    getterValue: 'payer_name',
    key:"id",
    options: true,
    type: "string",
    req_keys: "all",
    value: ""
  });
  payerId: any;
  constructor(
    public injector: Injector,
    public route: ActivatedRoute,
    public billingService: BillingService,
    public commonService:CommonService
  ) {
    super(injector, route);
    this.billingModel = new BillingModel();
    this.commonModel = new CommonModel();
  }

 
  ngOnInit() {
    console.log("Patient Info ", this.patientInfo);
    this.getPayerNames();
  }

  getSetPayerDetails() {
    let payerInfo = this.patientInfo;
    if (payerInfo) {
      if (payerInfo != undefined && payerInfo.payer_id) {
        this.billingModel.payerId = payerInfo.payer_id;
        let payer = this.billingModel.getPayerData.find(val => {
          return val.id == this.billingModel.payerId;
        });
        if (payer != undefined) {
          this.billingModel.payerId = payer.id;
          this.payerId = payer.id;
          this.payerQuestion.value = this.billingModel.payerId;
          this.billingModel.payerName = payer.payer_name;
          this.billingModel.payer_type = payer.payer_type;
          this.billingModel.payment_typeId = payer.payment_typeId;
          if (this.billingModel.payer_type != 'cash') {
            this.checkPayer();
          }
          this.billingModel.payerInputData = {
            "payer_type": this.billingModel.payer_type,
            "payer_id": this.billingModel.payerId,
            "payer_name": this.billingModel.payerName,
            "payment_typeId": this.billingModel.payment_typeId
          }
        } else {
          let payerName = this.billingModel.getPayerData.find(val => {
            return val.payer_type == 'cash';
          });
          if (payerName != undefined) {
            this.billingModel.payerId = payerName.id;
            this.payerId = payerName.id;
            this.billingModel.payerName = payerName.payer_name;
            this.billingModel.payer_type = payerName.payer_type;
            this.billingModel.payment_typeId = payerName.payment_typeId;
          }
        }
      } else {
        let payerName;
        if (this.billingModel.getPayerData) {
          payerName = this.billingModel.getPayerData.find(val => {
            return val.payer_type == 'cash';
          });
        }
        this.billingModel.payerInputData = {
          "payer_type": this.billingModel.payer_type,
          "payer_id": this.billingModel.payerId,
          "payer_name": this.billingModel.payerName,
          "payment_typeId": this.billingModel.payment_typeId
        }
        if (payerName != undefined) {
          this.billingModel.payerId = payerName.id;
          this.billingModel.payerName = payerName.payer_name;
          this.billingModel.payer_type = payerName.payer_type;
          this.billingModel.payment_typeId = payerName.payment_typeId;
          this.billingModel.payerInputData = {
            "payer_type": this.billingModel.payer_type,
            "payer_id": this.billingModel.payerId,
            "payer_name": this.billingModel.payerName,
            "payment_typeId": this.billingModel.payment_typeId
          }
          if (!payerInfo.hasOwnProperty('payer_type')) {
            payerInfo["payer_type"] = payerName.payer_type,
              payerInfo["payer_id"] = payerName.id,
              payerInfo["payer_name"] = payerName.payer_name,
              payerInfo["payment_typeId"] = payerName.payment_typeId
            if (this.billingModel.payer_type != 'cash') {
              this.checkPayer(payerInfo, false);
            }
            
          }
        }
      }
    }
  }
  checkPayer(obj?, hitApt?) {
    if(this.patientInfo){
      if(this.patientInfo.uhId || this.patientInfo.preRegistrationNo){
        let data = {
          'args': 'id:' + this.billingModel.payerId+",uhId:"+(this.patientInfo.uhId?this.patientInfo.uhId:this.patientInfo.preRegistrationNo),
          "query_id": "CHECK_PAYER_EXPRIY"
        }
        this.baseService.getData(data, "", 'payer', 'facility-management', 'CHECK_PAYER_EXPRIY').subscribe(
          result => {
            if (result.errCode == 0) {
              this.payerExpired = false;
              this.updatePayorInfo.emit({ currentData: obj, hitApt: hitApt, payerExpiry: this.payerExpired})
              console.log("Result ", result.resource);
            } else {
              this.payerExpired = true;
              this.updatePayorInfo.emit({ currentData: obj, hitApt: hitApt, payerExpiry: this.payerExpired})
            //   this.alerts.error(result.message);
            }
          }
        )
      }
    }
  }
  getUhId(){
    if(this.patientInfo){
      if(this.patientInfo.uhId){
        return this.patientInfo.uhId;
      }else if(this.patientInfo.preRegistrationNo){
        return this.patientInfo.preRegistrationNo;
      }
    }
  } 
  getPayerNames() {          // To get Payer List
    let resource = this.billingModel.getPayerArgs;
    var data = {
      args: `payer_for:pharmacy_billing,uhId:${this.getUhId()},rule_context:payerContext`
    }
    this.baseService.getData(data, "", resource.resource, resource.application, resource.query_id).subscribe(
      result => {
        if (result.errCode == 0) {
          this.billingModel.getPayerData = result.resource;
          this.getSetPayerDetails();
        }
      }
    )
  }
  changePayer(event) {    // After changing payer this function is called
    let payerName = this.billingModel.getPayerData.find(val => {
      return val.id == event.target.value;
    });
    this.billingModel.payerName = payerName.payer_name;
    this.billingModel.payer_type = payerName.payer_type;
    this.billingModel.payment_typeId = payerName.payment_typeId;
    this.billingModel.payerInputData = {
      "payer_type": this.billingModel.payer_type,
      "payer_id": this.billingModel.payerId,
      "payer_name": this.billingModel.payerName,
      "payment_typeId": this.billingModel.payment_typeId
    }
    console.log("patient data ", this.patientInfo);
    var obj = { ...this.patientInfo, ...this.billingModel.payerInputData }
    if (this.billingModel.payer_type != 'cash') {
      this.checkPayer(obj, true);
      this.updatePayorInfo.emit({ currentData: obj, hitApt: true, payerExpiry: this.payerExpired})
    } else {
      this.payerExpired = false;
      this.updatePayorInfo.emit({ currentData: obj, hitApt: true, payerExpiry: this.payerExpired})
    }
  }

  getPriceAPI(args, event?) {         // To get Price API
    let resource = this.commonModel.getPrice;
    resource['data'] = args;
    this.baseService.action(resource['data'], resource.action, resource.application, resource.resource).subscribe(response => {
      if (response.errCode == 0) {
        this.billingModel.dataTableData = response.resource[0].services;
        this.billingModel.dataTableData.forEach(element => {
          element['paymentStatus'] = 'completed';
          if (element['total_amount'] == undefined) {
            element['total_amount'] = element['amount'];
          }
          element['discountValue'] = element['discount'];
          if (element['serviceType_code'] == 'op_consultation') {
            element['consultation_type'] = 'opd';
          }
        });
      }
    });
  }
  openPayerInput(event) {          //Opening payer popup
    this.smartModalService.open(PayorDetailsItemConsumptionComponent, this.billingModel.payerInputData, "Payer Input", ModalSize.Md).subscribe(
      data => {
        this.billingModel.payerInputData = data.result.result;
        let args = {
          "payer_details": this.billingModel.payerInputData,
          "patient_id": this.patientInfo['id'],
          "facility_id": this.appService.getOrganization().org_id,
          "orderId": this.billingModel.orderId,
          "is_previous_order_required": false,
          "services": this.billingModel.dataTableData
        }
        this.updatePayorInfo.emit({ payerForm: data.result.result, hitApt: true, payerExpiry: this.payerExpired})
        //this.getPriceAPI(args);
      },
      err => {
        this.updatePayorInfo.emit();
        this.dialogRef.close();
      }
    )
  }

  checkUHID() {
    if (this.patientInfo.hasOwnProperty('uhId') && this.patientInfo.uhId) {
      return false;
    }
      return true 
  }
 

   onPayerDeselect(event){

   }
   onPayerSelect(event){
    this.changePayer(event.id)
   }
   ngOnChanges(changes) {
   }
 
}
